import { useEffect } from "react";

const BASE = "https://grantverify.org";
export const DEFAULT_META = {
  title: "GrantVerify | Small Business Grants, Proposals & Licensing",
  description: "GrantVerify helps small business owners find federal, state, county and city grants they qualify for, map every step, write the proposal and get it checked by a certified human editor. Free grant search, plans from $39/mo. By Peer Verify LLC.",
  path: "/",
};

function setTag(sel, attr, key, value) {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(sel.startsWith("link") ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(sel.startsWith("link") ? "href" : "content", value);
}

export function applyMeta({ title, description, path, image }) {
  const url = `${BASE}${path}`;
  const img = `${BASE}/${image || "og-image.png"}`;
  document.title = title;
  setTag('meta[name="description"]', "name", "description", description);
  setTag('link[rel="canonical"]', "rel", "canonical", url);
  setTag('meta[property="og:title"]', "property", "og:title", title);
  setTag('meta[property="og:description"]', "property", "og:description", description);
  setTag('meta[property="og:url"]', "property", "og:url", url);
  setTag('meta[property="og:image"]', "property", "og:image", img);
  setTag('meta[name="twitter:title"]', "name", "twitter:title", title);
  setTag('meta[name="twitter:description"]', "name", "twitter:description", description);
  setTag('meta[name="twitter:image"]', "name", "twitter:image", img);
}

export function usePageMeta(meta) {
  useEffect(() => {
    applyMeta(meta);
    return () => applyMeta(DEFAULT_META);
  }, [meta.title, meta.description, meta.path, meta.image]); // eslint-disable-line react-hooks/exhaustive-deps
}

export function useJsonLd(id, data) {
  const json = data ? JSON.stringify(data) : "";
  useEffect(() => {
    if (!json) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `ld-${id}`;
    el.text = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [id, json]);
}

export const faqLd = (items) => (items?.length ? { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: items.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) } : null);
